import Link from "next/link";
import { Tabs } from "ui";
import { useCarriedQueryParams } from "./utils";

export function PaymentsNavigationTabs({
  activeTab,
}: {
  activeTab: "intents" | "transactions" | "hostedPaymentPages";
}) {
  const query = useCarriedQueryParams();
  return (
    <Tabs value={activeTab}>
      <Tabs.List>
        <Tabs.Tab
          value="intents"
          nativeButton={false}
          render={<Link href={{ pathname: "/intents", query }} />}
        >
          Intents
        </Tabs.Tab>
        <Tabs.Tab
          value="transactions"
          nativeButton={false}
          render={<Link href={{ pathname: "/transactions", query }} />}
        >
          Transactions
        </Tabs.Tab>
        <Tabs.Tab
          value="hostedPaymentPages"
          nativeButton={false}
          render={<Link href={{ pathname: "/hosted-payment-pages", query }} />}
        >
          Hosted Payment Pages
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
